(function(exports)
{
  exports.components = exports.components || {}
  exports.components.Challenge = Vue.component('challenge',
  {
    template: '#challenge-template'
  })
})(window)
